module.exports = __webpack_public_path__ + "static/media/a-better-way.8ffd86b3.svg";